import OnLine from '@/components/OnLine';

class OffLine extends OnLine {
  render() {
    return (!this.state.isOnline && this.props.children) || null;
  }
}
export default OffLine;
